import Masonry from "masonry-layout";

const partners = {
  init() {
    partners.create();
  },
  create() {
    if ($("[data-global-partners]").length) {
      var grid = document.querySelector(".partners-masonry-grid");
      var msnry = new Masonry(grid, {
        columnWidth: ".panel.panel-global-partners .card a",
        horizontalOrder: true,
        percentPosition: true,
        // isOriginLeft: false,
      });

      $(document).on("click", "[data-thumb]", function (e) {
        e.preventDefault();
        const self = $(this);
        const idx = self.data("index");
        const eleP = self.closest("[data-global-partners]");
        const currentTotalThumbs = self
          .closest("[data-global-partners]")
          .find("[data-thumb]").length;
        const total = eleP.find("[data-partner]").length;

        const eleCurrent = eleP.find(`[data-partner].active`);
        const eleTarget = eleP.find(`[data-partner][data-index="${idx}"]`);

        if (eleTarget.length) {
          if (eleCurrent.length) {
            TweenMax.staggerTo(
              eleCurrent.find("[data-text]"),
              0.75,
              { opacity: 0 },
              0.15
            );
            // TweenMax.to(eleCurrentPortrait, 0.5, { opacity: 0 });
          }

          eleP.find("[data-partner]").removeClass("active");
          eleTarget.addClass("active");
          eleP.find("[data-portrait]").removeClass("active");
          // eleTargetPortrait.addClass("active");

          TweenMax.set(eleTarget.find("[data-text]"), {
            opacity: 0,
          });
          TweenMax.staggerTo(
            eleTarget.find("[data-text]"),
            0.75,
            { opacity: 1, x: 0 },
            0.15
          );

          // TweenMax.to(eleTargetPortrait, 0.75, { opacity: 1 });

          msnry.remove(self);

          if (total - currentTotalThumbs === 1) {
            // Append
            const fragment = document.createDocumentFragment();
            const elem = document.createElement("a");
            elem.classList.add("item");
            elem.classList.add("item-appended");
            elem.setAttribute(
              "data-thumb",
              ''
            );
            elem.setAttribute(
              "data-index",
              eleCurrent.data("index")
            );
            const span = document.createElement("span");
            span.classList.add("shape");
            elem.appendChild(span);

            const imgDiv = document.createElement("div");
            imgDiv.classList.add("img");
            imgDiv.classList.add("w-card");
            const img = document.createElement("img");
            img.src = eleCurrent.data("thumb-image");
            img.classList.add("object-cover");
            imgDiv.appendChild(img);
            elem.appendChild(imgDiv);

            const descDiv = document.createElement("div");
            descDiv.classList.add("copy");
            const descP = document.createElement("p");
            descP.textContent = eleCurrent.data("thumb-desc");
            descDiv.appendChild(descP);
            elem.appendChild(descDiv);

            fragment.appendChild(elem);
            grid.appendChild(fragment);
            msnry.appended([elem]);
            // End of Append
          }
        }

        msnry.layout();
      });

      $("[data-thumb]").eq(0).trigger("click");

      $("[data-partner-arrow]").on("click", function (e) {
        e.preventDefault();
        const self = $(this);
        const direction = self.data("partner-arrow");
        const total = self
          .closest(".panel-global-partners")
          .find("[data-partner]").length;
        const idxCurrent = parseInt(
          self
            .closest(".panel-global-partners")
            .find(`[data-partner].active`)
            .data("index")
        );
        let targetInd;

        if (direction === "next") {
          targetInd =
            idxCurrent + 1 > total - 1 ? 0 : idxCurrent + 1;
        } else {
          targetInd =
            idxCurrent - 1 < 0 ? total - 1 : idxCurrent - 1;
        }

        self
          .closest(".panel-global-partners")
          .find(`[data-thumb][data-index="${targetInd}"]`)
          .trigger("click");
      });
    }
  },
};

$(function () {
  partners.init();
});
